export const securityRoleGrpSteps = [
  {
    target: ".j_gp_adt",
    content: "View security group activity and audit details here.",
    placement: "left",
  },
  {
    target: ".j_srch",
    content: "Use the search box to quickly find a security group by name or description.",
    placement: "bottom",
  },
  {
    target: ".j_fil",
    content: "Click here to show filter options to refine the list of security groups.",
    placement: "bottom",
  },
  {
    target: ".j_g_create",
    content: "Click this button to create a new security group.",
    placement: "left",
  },
    {
    target: ".j_tbl1_col1",
    content: "This column has the expand icon, click to view all roles included within a group.",
    placement: "top",
  },
  {
    target: ".j_tbl2_nam",
    content: "This column shows the name of each security group.",
    placement: "top",
  },
  {
    target: ".j_tbl3_des",
    content: "This column shows the description of each security group.",
    placement: "top",
  },
  {
    target: ".j_tbl4_cre",
    content: "This column shows who created the security group and when.",
    placement: "top",
  },
  {
    target: ".j_tbl5_col5",
    content: "Use the actions column to edit or delete a security group.",
    placement: "top",
  },

];

